import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import Card from '../../../../../../shared/components/Card';
import {
  CardLabel,
  CardValue,
  LabelAndValueContainer,
} from '../../../../../../shared/components/Card/components/CardComponents';
import theme from '../../../../../../styles/theme';
import checkValue from '../../../../../../utils/values';
import ExportPdf from '../DownloadPdf/ExportPdf';
import Frame from './components/Frame';
import PdfBoletosIncome from './components/PdfBoletosIncome';
import PdfCardDomicílio from './components/PdfCardDomicilio';
import PdfCardIncome from './components/PdfCardIncome';
import PdfCardTev from './components/PdfCardTev';
import PdfCriptoIncome from './components/PdfCriptoIncome';
import PdfInvoice from './components/PdfInvoice';
import PdfMonthlyIncome from './components/PdfMonthlyIncome';
import PdfPixIncome from './components/PdfPixIncome';
import PdfTedIncome from './components/PdfTedIncome';

function IncomeDashboard() {
  const incomeFaresState = useSelector(
    (reducer: IReducer) => reducer.incomeFares
  );

  return (
    <Frame.Base isActive={incomeFaresState.isActive}>
      <Card
        isActive
        title="Valores para Nota"
        display="flex"
        highlighted="highlighted"
        gridArea="invoice"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        width="100%"
        margin="0 0.5rem 0"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Valores de Nota',
          body: <PdfInvoice />,
        })}>
        <LabelAndValueContainer style={{ height: '160px' }} alignCenter>
          <CardLabel>Valores para nota</CardLabel>
          <CardValue
            color={
              incomeFaresState.invoice.grossIncome >= 0
                ? theme.colors.mainColor
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.invoice.grossIncome).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title="TEDs"
        display="flex"
        gridArea="teds"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        width="100%"
        margin="0 0.5rem 0"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de TEDs',
          body: <PdfTedIncome />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.ted.received).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.ted.passedOn).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.ted.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.ted.income).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title="Boletos"
        display="flex"
        gridArea="boletos"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        margin="0 0.5rem 0"
        width="100%"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de Boletos',
          body: <PdfBoletosIncome />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.boleto.received).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.boleto.passedOn).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.boleto.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.boleto.income).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title="Mensalidade"
        display="flex"
        gridArea="monthlys"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        margin="0 0.5rem 0"
        width="100%"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de Manutenção de Contas',
          body: <PdfMonthlyIncome />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.monthly.received).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.monthly.passedOn).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.monthly.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.monthly.income).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>

      <Card
        isActive
        title="Pix"
        display="flex"
        gridArea="pix"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        margin="0 0.5rem 0"
        width="100%"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de Pix',
          body: <PdfPixIncome />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.pix.received).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.pix.passedOn).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.pix.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.pix.income).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive
        title="Cripto"
        display="flex"
        gridArea="cripto"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        margin="0 0.5rem 0"
        width="100%"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de Cripto',
          body: <PdfCriptoIncome />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.cripto.received).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.cripto.passedOn).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.cripto.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.cripto.income).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive
        title="Cartão"
        display="flex"
        gridArea="card"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        margin="0 0.5rem 0"
        width="100%"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de Cartão',
          body: <PdfCardIncome />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.card.received).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.card.passedOn).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.card.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.card.income).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive
        title="Domicílio Bancário"
        display="flex"
        gridArea="card"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        margin="0 0.5rem 0"
        width="100%"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de Domicílio Bancário',
          body: <PdfCardDomicílio />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.domicilio.received).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.domicilio.passedOn).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.domicilio.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.domicilio.income).toLocaleString(
              'pt-br',
              {
                style: 'currency',
                currency: 'BRL',
              }
            )}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
      <Card
        isActive
        title="TEV"
        display="flex"
        gridArea="card"
        justifyContent="space-around"
        flexDirection="column"
        height="100%"
        margin="0 0.5rem 0"
        width="100%"
        backgroundColor="#FFFFFF"
        rightButton={ExportPdf({
          title: 'Resumo de Receita de TEV',
          body: <PdfCardTev />,
        })}>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Recebido</CardLabel>
          <CardValue color={theme.colors.mainColor}>
            {checkValue(incomeFaresState.tev.received).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Repassado</CardLabel>
          <CardValue color={theme.colors.red}>
            {checkValue(incomeFaresState.tev.passedOn).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
        <LabelAndValueContainer alignCenter>
          <CardLabel>Resultado</CardLabel>
          <CardValue
            color={
              incomeFaresState.tev.income >= 0
                ? theme.colors.emphasis
                : theme.colors.red
            }>
            {checkValue(incomeFaresState.tev.income).toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL',
            })}
          </CardValue>
        </LabelAndValueContainer>
      </Card>
    </Frame.Base>
  );
}

export default IncomeDashboard;
